// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__AvQuf","errorLogs":"EditorFooter_errorLogs__1La7f"};